import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@/components/ui/base'
import { Modal } from '@/components/ui/base'
import { Spinner } from '@/components/ui/base'
import { useAuth } from '@/context/AuthContext'

export const Callback = () => {
  const navigate = useNavigate()
  const { isLoading, isAuthenticated } = useAuth()
  const hasRedirected = useRef(false)

  // BUG-001 fix: Wait for auth initialization instead of hardcoded timeout
  // AuthContext.initAuth() handles profile fetch and redirect to /create/profile if needed
  useEffect(() => {
    if (hasRedirected.current) return

    if (!isLoading) {
      hasRedirected.current = true
      console.log('✅ [CALLBACK] Auth initialized, redirecting', { isAuthenticated })
      navigate('/', { replace: true })
    }
  }, [isLoading, isAuthenticated, navigate])

  // Safety net: if auth takes longer than 10 seconds, redirect anyway
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasRedirected.current) {
        hasRedirected.current = true
        console.warn('⚠️ [CALLBACK] Auth timeout after 10s, redirecting to home')
        navigate('/', { replace: true })
      }
    }, 10000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#e5e7eb',
      }}
    >
      <Modal visible={true} onDismiss={() => {}} dismissible={false} size="small" header="Logging In">
        <Box textAlign="center" padding="l">
          <Spinner size="large" />
          <Box margin={{ top: 'm' }} color="text-body-secondary">
            Please wait while we set up your account...
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

export default Callback
